export const GET_CODE_INFO_REQUEST = 'GET_CODE_INFO_REQUEST'
export const GET_CODE_INFO_SUCCESS = 'GET_CODE_INFO_SUCCESS'
export const GET_CODE_INFO_FAILED = 'GET_CODE_INFO_FAILED'
